module.exports = __webpack_public_path__ + "img/59_2.892e8d23.png";